import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ComparisonService } from '../../../service/sage/comparison.service';

@Component({
  templateUrl: './public-comparison.component.html',
})
export class PublicComparisonComponent implements OnInit {

  comparison: any = null;
  items: any[] = [];
  loading = true;
  error = '';

  // Pricing tiers detected across all items
  tiers: number[] = [];

  constructor(
    private route: ActivatedRoute,
    private comparisonService: ComparisonService
  ) {}

  ngOnInit() {
    const encoded = this.route.snapshot.params['encoded'];
    let franchiseId = '';
    let token = '';
    try {
      // Reverse URL-safe base64: restore + and / then decode
      const decoded = atob(encoded.replace(/-/g, '+').replace(/_/g, '/'));
      const sep = decoded.indexOf(':');
      franchiseId = decoded.substring(0, sep);
      token = decoded.substring(sep + 1);
    } catch (e) {
      this.error = 'This share link is invalid.';
      this.loading = false;
      return;
    }
    this.comparisonService.getPublicComparison(token, franchiseId).subscribe(
      (res: any) => {
        const data = (res && res.data) ? res.data : res;
        if (data) {
          this.comparison = data;
          this.items = data.items || [];
          this.tiers = this.detectTiers();
        } else {
          this.error = 'Comparison not found.';
        }
        this.loading = false;
      },
      err => {
        const status = err && err.status;
        if (status === 404) {
          this.error = 'This share link is invalid or has been removed.';
        } else if (status === 410) {
          this.error = 'This share link has expired.';
        } else {
          this.error = 'Unable to load this comparison. Please try again later.';
        }
        this.loading = false;
      }
    );
  }

  pd(item: any): any {
    return item.product_data || {};
  }

  img(item: any): string {
    const p = this.pd(item);
    return p['PicLink'] || p['ThumbPicLink'] || p['DefaultMediaPath'] || '';
  }

  detectTiers(): number[] {
    const found: number[] = [];
    for (let n = 1; n <= 9; n++) {
      const hasData = this.items.some(item => {
        const qty = this.pd(item)['Qty' + n];
        return qty && parseFloat(qty) > 0;
      });
      if (hasData) { found.push(n); }
    }
    return found;
  }

  formatPrice(val: any): string {
    if (val === null || val === undefined || val === '') { return '—'; }
    const n = parseFloat(val);
    return isNaN(n) || n === 0 ? '—' : '$' + n.toFixed(2);
  }

  formatNum(val: any): string {
    if (val === null || val === undefined || val === '') { return '—'; }
    const n = parseFloat(val);
    return isNaN(n) || n === 0 ? '—' : n.toLocaleString('en-US', { maximumFractionDigits: 0 });
  }

  val(item: any, key: string): string {
    const v = this.pd(item)[key];
    return (v !== null && v !== undefined && v !== '') ? v : '—';
  }
}

